/* eslint-disable react/jsx-filename-extension */
import { push } from "connected-react-router";
import { actions as debinActions } from "reducers/debin";
import { actions as accountsActions } from "reducers/accounts";

export default function specialOptions(debin, environmentCuit, functionAction) {
    let contextSpecialMenuActions = [];
    switch (debin.estado) {
        case "INICIADO": {
            contextSpecialMenuActions = [
                {
                    label: `anulate.debin`,
                    onClick: () => functionAction("ANULATE", debin),
                },
            ];
            break;
        }

        default: {
            break;
        }
    }

    return contextSpecialMenuActions;
}

export const receivedDebinAction = (action, debin, dispatch) => {
    if (action === "ANULATE") {
        dispatch(debinActions.getDebinDetail(debin.id));
        dispatch(accountsActions.listAccountsCbu());
    }

    switch (action) {
        case "ANULATE": {
            dispatch(push("/debinPayments/action/anulate"));
            break;
        }
        default:
            break;
    }
};
